import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { EconomyService, PriceListItem } from '../../../services/economy.service';

@Component({
    selector: 'tt-price-lists',
    templateUrl: './price-lists.component.html',
    styleUrls: ['./price-lists.component.css'],
})
export class PriceListsComponent implements OnInit {
    public itemsListPrices: PriceListItem[] = [];

    constructor(
        private stateService: StateService,
        private economy: EconomyService,
    ) {}

    private async loadPrices() {
        this.itemsListPrices = await this.economy.getPriceLists();
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'pricelist':
                this.stateService?.go('pricelist', { pricelist_id: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadPrices();
    }

    ngOnInit() {
        this.init();
    }
}
